const HcpLogo = <template>
  <svg
    ...attributes
    class="hcpLogo"
    id="Logos"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 560.06 72"
  >
    <g>
      <path
        d="m30.19,17.3l-14.4,8.2v19.7l5.4,3.1v-19.8l8.9-5.1v-6.1h.1Z"
        fill="#fff"
      />
      <path
        d="m35.89,17.3v15.7h-5.7v-5.9l-5.4,3.1v20.1l5.4,3.1v-15.7h5.7v5.8l5.4-3.1v-20.1l-5.4-3Z"
        fill="#fff"
      />
      <path
        d="m50.19,45.2l-14.3,8.2v-6.2l8.9-5.1v-19.7l5.4,3.1v19.7Z"
        fill="#fff"
      />
      <g>
        <path
          d="m86.74,23.03h5.12v11.52h12.48v-11.52h5.12v28h-5.12v-11.84h-12.48v11.84h-5.12v-28Z"
          fill="#fff"
        />
        <path
          d="m112.98,45.58c0-4.2,3-5.56,6.56-6.4l6.16-1.44v-.44c0-2.12-1.4-3.44-3.56-3.44s-3.44,1.2-3.88,3.12l-4.4-.52c.68-3.8,3.88-6.24,8.48-6.24,5.04,0,8.32,3.16,8.32,7.8v8.36c0,.52.16.72.52.72h1.12v3.92h-3c-1.96,0-2.8-.6-2.8-2.24,0-.48.08-1.08.28-1.8l-.44-.12c-1.44,3.08-3.56,4.48-6.64,4.48-4.04,0-6.72-2.24-6.72-5.76Zm8.04,2.12c2.76,0,4.68-2,4.68-5.16v-1.56l-4.52,1.08c-2.24.52-3.2,1.28-3.2,3.04,0,1.6,1.2,2.6,3.04,2.6Z"
          fill="#fff"
        />
        <path
          d="m134.34,45.5l4.68-.96c.52,2.24,2.32,3.36,4.64,3.36s3.68-1,3.68-2.56c0-1.64-1.56-1.96-4.52-2.52-3.56-.56-8.28-1.2-8.28-6.2,0-3.8,3.24-6.4,8.44-6.4,4.64,0,8.24,1.96,9.08,5.88l-4.72.76c-.48-2-2.16-3.08-4.36-3.08-2.4,0-3.6,1.04-3.6,2.4,0,1.64,1.6,2,4.52,2.52,3.6.56,8.28,1.24,8.28,6.24,0,3.92-3.2,6.52-8.52,6.52-4.88,0-8.44-1.96-9.32-5.96Z"
          fill="#fff"
        />
        <path
          d="m160.5,51.02h-5v-28.79h5v9.04c0,1.04-.2,2.04-.48,3.52l.48.12c1.24-2.96,3.16-4.68,6.64-4.68,4.44,0,6.8,2.8,6.8,7.56v13.24h-5v-13.08c0-2.4-1.2-3.76-3.6-3.76-2.68,0-4.84,2.04-4.84,5.72v11.12Z"
          fill="#fff"
        />
        <path
          d="m184.61,46.02c0,.8.28,1,.88,1h2.32v4h-4.6c-2.36,0-3.6-1.28-3.6-3.68v-12.68h-2.92v-4h7.92v15.36Zm-5.72-20.84c0-1.68,1.4-3.08,3.04-3.08,1.72,0,3.08,1.4,3.08,3.08s-1.36,3.12-3.08,3.12-3.04-1.36-3.04-3.12Z"
          fill="#fff"
        />
        <path
          d="m189.7,37.02c0-8.4,5.48-14.48,13.48-14.48,6.64,0,11.24,3.88,12.52,9.2l-5.08,1.2c-1.04-3.76-3.52-5.92-7.44-5.92-5,0-8.16,4.16-8.16,10s3.28,10,8.32,10c4,0,6.44-2.2,7.48-6.2l4.84.56c-1.24,6.24-5.88,10.12-12.4,10.12-8,0-13.56-6.08-13.56-14.48Z"
          fill="#fff"
        />
        <path
          d="m217.94,40.86c0-6.2,4.28-10.64,10.32-10.64s10.36,4.44,10.36,10.64-4.36,10.6-10.36,10.6-10.32-4.4-10.32-10.6Zm15.68,0c0-3.92-2.12-6.56-5.36-6.56s-5.36,2.64-5.36,6.56,2.16,6.56,5.36,6.56,5.36-2.64,5.36-6.56Z"
          fill="#fff"
        />
        <path
          d="m242.02,30.67h4.64v.84c0,1.12-.04,2-.36,3.6l.48.12c.76-2.68,2.16-4.56,5.44-4.56h1.48v4.88h-2.04c-3,0-4.64,1.84-4.64,5.2v10.28h-5v-20.36Z"
          fill="#fff"
        />
        <path
          d="m256.26,30.67h4.92v1c0,.92-.08,1.64-.36,3.28l.48.12c1.24-3.28,3.6-4.84,6.6-4.84,5,0,8.92,4.08,8.92,10.6s-3.92,10.64-8.92,10.64c-3,0-5.24-1.56-6.52-4.84l-.44.16c.24,1.6.32,2.36.32,3.24v9.2h-5v-28.56Zm15.6,10.2c0-4.08-2.24-6.56-5.32-6.56s-5.32,2.48-5.32,6.56,2.2,6.56,5.32,6.56,5.32-2.52,5.32-6.56Z"
          fill="#fff"
        />
        <path
          d="m287.09,37.02c0-8.4,5.48-14.48,13.48-14.48,6.64,0,11.24,3.88,12.52,9.2l-5.08,1.2c-1.04-3.76-3.52-5.92-7.44-5.92-5,0-8.16,4.16-8.16,10s3.28,10,8.32,10c4,0,6.44-2.2,7.48-6.2l4.84.56c-1.24,6.24-5.88,10.12-12.4,10.12-8,0-13.56-6.08-13.56-14.48Z"
          fill="#fff"
        />
        <path
          d="m322.61,46.1c0,.76.28,1,.84,1h2.44v3.92h-4.68c-2.36,0-3.6-1.28-3.6-3.68v-21.16h-2.96v-3.96h7.96v23.88Z"
          fill="#fff"
        />
        <path
          d="m327.57,40.86c0-6.2,4.28-10.64,10.32-10.64s10.36,4.44,10.36,10.64-4.36,10.6-10.36,10.6-10.32-4.4-10.32-10.6Zm15.68,0c0-3.92-2.12-6.56-5.36-6.56s-5.36,2.64-5.36,6.56,2.16,6.56,5.36,6.56,5.36-2.64,5.36-6.56Z"
          fill="#fff"
        />
        <path
          d="m364.93,30.67h5v20.36h-4.88v-.84c0-1.04.08-1.8.32-3.24l-.44-.16c-1.24,3-3.16,4.68-6.64,4.68-4.44,0-6.8-2.76-6.8-7.52v-13.28h5v12.84c0,2.68,1.16,4.04,3.72,4.04,2.72,0,4.72-2.08,4.72-5.68v-11.2Z"
          fill="#fff"
        />
        <path
          d="m373.41,40.86c0-6.52,3.92-10.64,8.92-10.64,3.04,0,5.28,1.56,6.52,4.84l.48-.12c-.28-1.64-.36-2.36-.36-3.28v-9.44h5v28.79h-4.88v-1c0-.88.04-1.64.32-3.24l-.44-.16c-1.28,3.28-3.6,4.84-6.64,4.84-5,0-8.92-4.04-8.92-10.6Zm15.64,0c0-4.08-2.24-6.56-5.32-6.56s-5.36,2.48-5.36,6.56,2.24,6.56,5.36,6.56,5.32-2.52,5.32-6.56Z"
          fill="#fff"
        />
        <path
          d="m406.29,23.03h9.88c6.8,0,11.04,3.28,11.04,9.2s-4.24,9.24-11.04,9.24h-4.76v9.56h-5.12v-28Zm9.88,14.16c3.84,0,5.84-1.64,5.84-4.96s-2-4.88-5.84-4.88h-4.76v9.84h4.76Z"
          fill="#fff"
        />
        <path
          d="m436.57,46.1c0,.76.28,1,.84,1h2.44v3.92h-4.68c-2.36,0-3.6-1.28-3.6-3.68v-21.16h-2.96v-3.96h7.96v23.88Z"
          fill="#fff"
        />
        <path
          d="m441.69,45.58c0-4.2,3-5.56,6.56-6.4l6.16-1.44v-.44c0-2.12-1.4-3.44-3.56-3.44s-3.44,1.2-3.88,3.12l-4.4-.52c.68-3.8,3.88-6.24,8.48-6.24,5.04,0,8.32,3.16,8.32,7.8v8.36c0,.52.16.72.52.72h1.12v3.92h-3c-1.96,0-2.8-.6-2.8-2.24,0-.48.08-1.08.28-1.8l-.44-.12c-1.44,3.08-3.56,4.48-6.64,4.48-4.04,0-6.72-2.24-6.72-5.76Zm8.04,2.12c2.76,0,4.68-2,4.68-5.16v-1.56l-4.52,1.08c-2.24.52-3.2,1.28-3.2,3.04,0,1.6,1.2,2.6,3.04,2.6Z"
          fill="#fff"
        />
        <path
          d="m465.65,45.9v-11.24h-3.64v-4h3.64v-5.16h5v5.16h5.04v4h-5.04v10.64c0,1.28.48,1.76,1.52,1.76h3.52v3.96h-4.44c-3.92,0-5.6-1.56-5.6-5.12Z"
          fill="#fff"
        />
        <path
          d="m480.29,34.66h-3.68v-4h3.68v-3.16c0-3.68,1.72-5.28,5.72-5.28h4.52v3.96h-3.64c-1.2,0-1.68.56-1.68,1.88v2.6h4.76v4h-4.68v16.36h-5v-16.36Z"
          fill="#fff"
        />
        <path
          d="m491.25,40.86c0-6.2,4.28-10.64,10.32-10.64s10.36,4.44,10.36,10.64-4.36,10.6-10.36,10.6-10.32-4.4-10.32-10.6Zm15.68,0c0-3.92-2.12-6.56-5.36-6.56s-5.36,2.64-5.36,6.56,2.16,6.56,5.36,6.56,5.36-2.64,5.36-6.56Z"
          fill="#fff"
        />
        <path
          d="m515.33,30.67h4.64v.84c0,1.12-.04,2-.36,3.6l.48.12c.76-2.68,2.16-4.56,5.44-4.56h1.48v4.88h-2.04c-3,0-4.64,1.84-4.64,5.2v10.28h-5v-20.36Z"
          fill="#fff"
        />
        <path
          d="m529.57,30.67h4.88v.88c0,1.08-.08,1.8-.36,3.24l.48.12c1.04-3.16,3.08-4.68,6.28-4.68s5.36,1.48,6.12,4.6h.44c1.08-3.08,3.12-4.6,6.16-4.6,4.2,0,6.44,2.72,6.44,7.4v13.4h-4.72v-13.24c0-2.32-1.16-3.6-3.24-3.6-2.72,0-4.64,2.28-4.64,5.64v11.2h-5v-13.24c0-2.32-1.12-3.6-3.2-3.6-2.68,0-4.64,2.28-4.64,5.64v11.2h-5v-20.36Z"
          fill="#fff"
        />
      </g>
    </g>
    <path
      d="m57.17,68.98H8.8c-1.56,0-2.7,0-3.61-.07-.96-.08-1.62-.24-2.18-.52-1.04-.53-1.87-1.36-2.4-2.4-.29-.57-.45-1.22-.52-2.18-.07-.92-.07-2.05-.07-3.61V11.81c0-1.56,0-2.69.07-3.61.08-.96.24-1.62.52-2.18.53-1.04,1.36-1.87,2.4-2.4.57-.29,1.22-.45,2.18-.52.92-.07,2.05-.07,3.61-.07h48.38c1.56,0,2.69,0,3.61.07.96.08,1.62.24,2.18.52,1.04.53,1.87,1.36,2.4,2.4.29.57.45,1.22.52,2.18.07.92.07,2.05.07,3.61v48.38c0,1.56,0,2.7-.07,3.61-.08.97-.24,1.62-.52,2.18-.53,1.04-1.36,1.87-2.4,2.4-.57.29-1.22.45-2.18.52-.92.07-2.05.07-3.61.07ZM8.8,5.76c-1.5,0-2.58,0-3.39.07-.56.05-.94.12-1.16.23-.52.27-.94.68-1.2,1.2-.11.22-.19.6-.23,1.16-.07.81-.07,1.89-.07,3.39v48.38c0,1.44,0,2.58.07,3.39.05.56.12.94.23,1.16.27.52.68.94,1.2,1.2.22.11.6.19,1.16.23.8.07,1.89.07,3.39.07h48.38c1.5,0,2.58,0,3.39-.07.56-.05.94-.12,1.16-.23.52-.27.94-.68,1.2-1.2.11-.22.19-.6.23-1.16.07-.8.07-1.89.07-3.39V11.81c0-1.5,0-2.58-.07-3.39-.05-.56-.12-.94-.23-1.16-.27-.52-.68-.94-1.2-1.2-.22-.11-.6-.19-1.16-.23-.81-.07-1.94-.07-3.39-.07H8.8Z"
      fill="#fff"
    />
  </svg>
</template>;

export default HcpLogo;
